import { ConfigProvider } from "antd"

// Портал бүхэлдээ нэг өнгө/дүрсийн систем: Томүжин ягаан-нил (#5c1090) үндсэн,
// зөөлөн булан, тод хүрээгүй карт — цэвэрхэн хэв маяг.
function StyleConfigProvider ({children}) {
  return(
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#5c1090',
          colorInfo: '#5c1090',
          colorSuccess: '#16a34a',
          colorWarning: '#d97706',
          colorError: '#dc2626',
          colorBgLayout: '#f4f5f9',
          colorBorder: '#e5e7eb',
          borderRadius: 12,
          borderRadiusSM: 8,
          borderRadiusLG: 16,
          fontFamily: '"Raleway", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          fontSize: 14,
          controlHeight: 40,
        },
        components: {
          Button: { controlHeight: 42, fontWeight: 600, primaryShadow: 'none' },
          Card: { paddingLG: 20 },
          Tag: { borderRadiusSM: 999 },
          Modal: { borderRadiusLG: 20 },
          Input: { controlHeight: 44 },
          DatePicker: { controlHeight: 42 },
          Select: { controlHeight: 42 },
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

export default StyleConfigProvider
